import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import pl from '../media/pageLoad.gif'

function PageLoad() {
    const [countdown, setCountdown] = useState(6);


    useEffect(() => {
        if (countdown === 0) {
          window.location.href = '/login'
          return;
        }
    
        const timer = setTimeout(() => {
          setCountdown(prevCountdown => prevCountdown - 1);
        }, 1000);
    

        return () => clearTimeout(timer);
      }, [countdown]);


  return (
    <Container>
        <img src={pl} />
    </Container>
  )
}

export default PageLoad


const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    z-index: 10000;

    > img {
        object-fit: contain;
        width: 200px;
    }
`